import { AbstractControl } from '@angular/forms';

const ADDRESS_TYPES = [
  'avenida', 'av', 'av.', 'ave', 'avda', 'avda.',
  'calle', 'cl', 'cl.', 'c/',
  'jirón', 'jiron', 'jr', 'jr.',
  'pasaje', 'pj', 'pj.', 'psje', 'psje.',
  'prolongación', 'prolongacion', 'prolg', 'prolg.', 'prolong',
  'carretera', 'carr', 'carr.', 'ctra', 'ctra.',
  'autopista',
  'vía expresa', 'via expresa',
  'urbanización', 'urbanizacion', 'urb', 'urb.',
  'residencial', 'res', 'res.',
  'asociación', 'asociacion', 'asoc', 'asoc.',
  'cooperativa', 'coop', 'coop.',
  'conjunto', 'conj', 'conj.',
  'parque',
  'alameda'
];

export function AddressValidator(control: AbstractControl) {
  if (!control.value || typeof control.value !== 'string') {
    return null;
  }

  const addressValue = control.value;
  const words = addressValue.split(/\s+/).filter(word => word.length > 0);
  if (words.length < 2) {
    return { addressInvalid: true };
  }

  const addressLower = addressValue.toLowerCase();
  const hasAddressType = ADDRESS_TYPES.some(addressType => {
    const addressTypeLower = addressType.toLowerCase();
    if (addressTypeLower.includes(' ')) {
      return addressLower.includes(addressTypeLower);
    } else {
      return words.some(word => {
        return word.toLowerCase() === addressTypeLower;
      });
    }
  });

  if (!hasAddressType) {
    return { addressInvalid: true };
  }

  return null;
}

